import cx from "classnames";
import { FC, SVGProps } from "react";
import { NavLink } from "react-router-dom";

import { Icon } from "atoms/icon/Icon";

interface ItemProps {
  /** Icon */
  svg: FC<SVGProps<SVGSVGElement>>;

  /** Where does it redirect to. */
  to: string;

  /** Label */
  label: string;

  /** Override the active state (used for custom navigation scenarios). */
  isActiveOverride?: boolean;

  intentPreload?: () => void;
}

/** Footer item. */
export const Item = ({ svg, to, label, isActiveOverride, intentPreload }: ItemProps) => {
  return (
    <NavLink
      className={cx(
        "relative z-10 flex flex-1 flex-col items-center transition-opacity duration-150 active:opacity-60",
      )}
      to={to}
      data-testid={`nav-link-${label.toLowerCase()}`}
      onTouchStart={intentPreload}
      onMouseEnter={intentPreload}
      onFocus={intentPreload}
    >
      {({ isActive: navLinkIsActive }) => {
        const isActive = isActiveOverride ?? navLinkIsActive;
        return (
          <div
            className="flex scale-90 flex-col items-center justify-center"
            data-active={isActive}
          >
            <Icon color={isActive ? "brandColor" : "darkGrey"} svg={svg} />
            <div
              className={cx(
                "text-[10px] font-semibold capitalize leading-[11px] transition-colors duration-150",
                isActive ? "text-primary" : "text-secondary",
              )}
            >
              {label}
            </div>
          </div>
        );
      }}
    </NavLink>
  );
};
